/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc
 */
import * as References from './DashworksRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#fetchAppParams
 */
export const FETCH_APP_PARAMS_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_fetchAppParams';
export const FETCH_APP_PARAMS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_APP_PARAMS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.fetchAppParamsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#storeUserAppSecret
 */
export const STORE_USER_APP_SECRET_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_storeUserAppSecret';
export const STORE_USER_APP_SECRET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: STORE_USER_APP_SECRET_QUERY_FIELD_NAME,
  args: ['appId', 'secretId', 'authenticatorId', 'userScope'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.storeUserAppSecretRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#getAppIds
 */
export const GET_APP_IDS_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_getAppIds';
export const GET_APP_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APP_IDS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getAppIdsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#getUserConnectedApps
 */
export const GET_USER_CONNECTED_APPS_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_getUserConnectedApps';
export const GET_USER_CONNECTED_APPS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_CONNECTED_APPS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getUserConnectedAppsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#disconnectUserApp
 */
export const DISCONNECT_USER_APP_MUTATION_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_disconnectUserApp';
export const DISCONNECT_USER_APP_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DISCONNECT_USER_APP_MUTATION_FIELD_NAME,
  args: ['appId', 'deleteOption'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.disconnectUserAppRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#testGimmieSetup
 */
export const TEST_GIMMIE_SETUP_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_testGimmieSetup';
export const TEST_GIMMIE_SETUP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: TEST_GIMMIE_SETUP_QUERY_FIELD_NAME,
  args: ['appNames', 'appNamespace', 'sourcePortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.testGimmieSetupRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#testGimmieCleanup
 */
export const TEST_GIMMIE_CLEANUP_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_testGimmieCleanup';
export const TEST_GIMMIE_CLEANUP_QUERY = /* #__PURE__ */registerQuery({
  fieldName: TEST_GIMMIE_CLEANUP_QUERY_FIELD_NAME,
  args: ['appNames', 'appNamespace'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.testGimmieCleanupRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#runRetrievalEvalSingle
 */
export const RUN_RETRIEVAL_EVAL_SINGLE_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_runRetrievalEvalSingle';
export const RUN_RETRIEVAL_EVAL_SINGLE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RUN_RETRIEVAL_EVAL_SINGLE_QUERY_FIELD_NAME,
  args: ['query', 'goldenDocumentId', 'appName'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.runRetrievalEvalSingleRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#runRetrievalEval
 */
export const RUN_RETRIEVAL_EVAL_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_runRetrievalEval';
export const RUN_RETRIEVAL_EVAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RUN_RETRIEVAL_EVAL_QUERY_FIELD_NAME,
  args: ['queries', 'appNames'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.runRetrievalEvalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc#runRetrievalEvalFromGoogleSheet
 */
export const RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY_FIELD_NAME = 'com_hubspot_dashworks_rpc_DashworksRpc_runRetrievalEvalFromGoogleSheet';
export const RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RUN_RETRIEVAL_EVAL_FROM_GOOGLE_SHEET_QUERY_FIELD_NAME,
  args: ['spreadsheetUrl', 'appName'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.runRetrievalEvalFromGoogleSheetRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});